/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import {
  MdOutlinePerson,
  MdOutlineLock,
  MdCreditCard,
  MdOutlinePhone,
  MdOutlineMail,
  MdOutlineBadge,
  MdOutlineInfo,
} from "react-icons/md";
import moderatorService from "../../../services/moderator.service";
import AuthService from "../../../services/auth.service";

const CreateModerator = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const editItem = state?.item || null;

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({
    phonecodes: [],
    documentTypes: [],
  });

  const [form, setForm] = useState({
    name: "",
    email: "",
    lastname: "",
    level_id: "",
    phonecode_id: "",
    phone: "",
    document: "",
    document_type_id: "",
    password: "",
    password_confirmation: "",
  });

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const res = await AuthService.getDocumentTypes({ user_id: editItem?.id });
      setMeta((prev) => ({
        ...prev,
        documentTypes: res.document_types || [],
        phonecodes: res.phonecodes || [],
      }));

      if (res.user) {
        setForm((prev) => ({
          ...prev,
          name: res.user.name || "",
          email: res.user.email || "",
          lastname: res.user.lastname || "",
          level_id: res.user.level_id ? String(res.user.level_id) : "",
          phonecode_id: res.user.phonecode_id
            ? String(res.user.phonecode_id)
            : "",
          phone: res.user.phone || "",
          document: res.user.document || "",
          document_type_id: res.user.document_type_id
            ? String(res.user.document_type_id)
            : "",
        }));
      }
    } catch (error) {
      toast.error("Error al cargar los datos iniciales");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if ((name === "document" || name === "phone") && !/^\d*$/.test(value))
      return;

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password && form.password !== form.password_confirmation) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      if (editItem) {
        await moderatorService.admin.update({ ...form, user_id: editItem.id });
        toast.success("Se ha modificado el moderador correctamente");
      } else {
        await moderatorService.admin.create({ ...form });
        toast.success("Se ha creado el moderador correctamente");
      }
      navigate(-1);
    } catch (error) {
      toast.error("Error al guardar los datos del moderador");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto py-6 px-4 md:px-8">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="flex border-b border-gray-100 bg-gray-50/50">
          <button
            type="button"
            className={`flex-1 flex items-center justify-center gap-2 py-4 font-semibold text-sm transition-colors ${
              activeTab === 0
                ? "text-[#1D3B8B] border-b-2 border-[#1D3B8B] bg-white"
                : "text-gray-500 hover:text-[#1D3B8B]"
            }`}
            onClick={() => setActiveTab(0)}
          >
            <MdOutlinePerson size={20} />
            DATOS PERSONALES
          </button>
          <button
            type="button"
            className={`flex-1 flex items-center justify-center gap-2 py-4 font-semibold text-sm transition-colors ${
              activeTab === 1
                ? "text-[#1D3B8B] border-b-2 border-[#1D3B8B] bg-white"
                : "text-gray-500 hover:text-[#1D3B8B]"
            }`}
            onClick={() => setActiveTab(1)}
          >
            <MdOutlineLock size={20} />
            SEGURIDAD
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 md:p-8">
          {activeTab === 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nombre
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                  <MdOutlinePerson className="text-gray-400 mr-2" size={20} />
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Nombre"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Apellido
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                  <MdOutlinePerson className="text-gray-400 mr-2" size={20} />
                  <input
                    type="text"
                    name="lastname"
                    value={form.lastname}
                    onChange={handleChange}
                    placeholder="Apellido"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cédula o RIF
                </label>
                <div className="flex gap-3">
                  <select
                    name="document_type_id"
                    value={form.document_type_id}
                    onChange={handleChange}
                    className="w-1/3 md:w-1/4 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-[#1D3B8B] text-gray-800"
                  >
                    <option value="">-</option>
                    {meta.documentTypes.map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.name}
                      </option>
                    ))}
                  </select>
                  <div className="flex-1 flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                    <MdCreditCard className="text-gray-400 mr-2" size={20} />
                    <input
                      type="text"
                      name="document"
                      value={form.document}
                      onChange={handleChange}
                      placeholder="Cédula o RIF"
                      className="bg-transparent w-full outline-none text-gray-800"
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Teléfono
                </label>
                <div className="flex gap-3">
                  <div className="flex items-center w-1/3 md:w-1/4 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                    <MdOutlinePhone className="text-gray-400 mr-1" size={18} />
                    <select
                      name="phonecode_id"
                      value={form.phonecode_id}
                      onChange={handleChange}
                      className="bg-transparent w-full outline-none text-gray-800"
                    >
                      <option value="">-</option>
                      {meta.phonecodes.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex-1 flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                    <MdOutlinePhone className="text-gray-400 mr-2" size={18} />
                    <input
                      type="text"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="Número de teléfono"
                      className="bg-transparent w-full outline-none text-gray-800"
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Correo electrónico (Será su usuario)
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                  <MdOutlineMail className="text-gray-400 mr-2" size={20} />
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Correo electrónico"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de usuario
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineBadge className="text-gray-400 mr-2" size={20} />
                  <select
                    name="level_id"
                    value={form.level_id}
                    onChange={handleChange}
                    className="bg-transparent w-full outline-none text-gray-800"
                  >
                    <option value="">Seleccione tipo de usuario</option>
                    <option value="1">Super admin</option>
                    <option value="5">Agente</option>
                    <option value="4">Receptor</option>
                  </select>
                </div>
              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {editItem
                    ? "Cambiar contraseña (Opcional)"
                    : "Contraseña de Acceso"}
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineLock className="text-gray-400 mr-2" size={20} />
                  <input
                    type="password"
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Contraseña"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Repetir contraseña
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineLock className="text-gray-400 mr-2" size={20} />
                  <input
                    type="password"
                    name="password_confirmation"
                    value={form.password_confirmation}
                    onChange={handleChange}
                    placeholder="Repetir contraseña"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div className="bg-blue-50/50 border border-blue-100 rounded-xl p-4 flex gap-3 mt-4">
                <MdOutlineInfo
                  className="text-[#1D3B8B] shrink-0 mt-0.5"
                  size={22}
                />
                <div>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">
                    Información importante
                  </h4>
                  <p className="text-sm text-gray-600">
                    Cambie la contraseña solo si es necesario, los campos vacíos
                    no representan un problema.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="mt-8 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-[#1D3B8B] text-white px-8 py-3 rounded-xl font-bold shadow-md hover:bg-[#152a66] transition-colors disabled:opacity-70 disabled:cursor-not-allowed w-full md:w-auto"
            >
              {loading ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateModerator;
